

import React, { Fragment } from 'react'
import { Card, Col, Container, Row, Button, CardBody, Input } from 'reactstrap';
import { useSeller } from '../../../hooks/seller/useSeller';
import { ModalSeller } from './ModalSeller';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DialogTransfer } from './DialogTransfer';

export const IndexSeller = () => {

  const {
    name, paternal_surname, maternal_surname, number_phone, email, sellerD, handleInputChange, handleCreate,
    method, modalTitle, loading, toggle, modal,
    totalPageCount, currentPage, nextPage, previousPage, goToPage, handleSearchSeller,
    saveCreate, handleUpdate, saveUpdate, handleDelete, saveDelete, validaciones,
    handleExportExcelSeller, loadingExport, closeModalSeller,
    searchSeller, handleClearSeller, modalTransfer, closeTransfer, handleCreateTransfer,
    listSellers,id_seller_origin, id_seller_destiny, handleTransfer,
    id_seller, showConfirm, setShowConfirm, getDoctorsCount, doctorCount,
    errorTransfer, setErrorTransfer, handleShowConfirm, listSellerAll


  } = useSeller();

  const headerStyle = {
    backgroundColor: "#1d5b83",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "11px",
    borderRight: "1px solid #fff",
    borderBottom: "2px solid #fff",
  };

  const cellStyle = {
    fontSize: "11px",
    padding: "5px",
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",

  };

  const centerStyle = {
    ...cellStyle,
    textAlign: "center",
  };

   const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_seller)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_seller)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

    let _transferSeller = localStorage.getItem('configuration_seller');

    return (
    <Fragment>
      <div className='container-global-zoom' >
        <Row>
            <Col sm="12">
            <Card>
              <CardBody className='p-1'>
                <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                    <TitleDataTable
                        titleTable="Vendedores"
                        buttonActions={handleExportExcelSeller}
                        titleButton="listado de Vendedores "
                        isDisbled={loadingExport}
                        loadingIsDisabled={loadingExport}
                        titleCreate="Crear Vendedor"
                        buttonActionsCreate={handleCreate}
                        actionInput={handleSearchSeller}
                        valueFilter={searchSeller}
                        filterLocalStorage={true}
                        cleanFilterLocalStorage={handleClearSeller}
                      

                         {...(_transferSeller === "True" && {
                                tranferButton: true,
                                titleButtonTransfire: "Transferir cartera de clientes",
                                buttonTransfire: handleCreateTransfer
                            })}
                    />
                </Col>
                 
                <div className="table-responsive">
                  <DataTable
                    value={sellerD}
                    paginator
                    rows={10}
                    responsiveLayout="scroll"
                    rowsPerPageOptions={[10, 50, 100]}
                    className="data-table p-datatable-striped p-datatable-sm"
                    emptyMessage={
                      <div className="text-center">
                        <img
                          src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                          style={{ width: "32%" }}
                          alt="Sin resultados"
                        />
                        <br />
                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                          No se encontraron resultados.
                        </p>
                      </div>
                    }
                  >

                    <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                    <Column field="name" header="Nombre" headerStyle={headerStyle} style={cellStyle} />
                    <Column field="paternal_surname" header="Apellido Paterno" headerStyle={headerStyle} style={cellStyle} />
                    <Column field="maternal_surname" header="Apellido Materno" headerStyle={headerStyle} style={cellStyle} />
                    <Column field="number_phone" header="Teléfono" headerStyle={headerStyle} style={cellStyle} />
                    <Column field="email" header="Correo electrónico" headerStyle={headerStyle} style={cellStyle} />
                    <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />

                  </DataTable>
                </div>
              </CardBody>
            </Card>
          </Col>

        </Row>
        
      </div>
      <ModalSeller
        {
        ...{
          modal, toggle, modalTitle, method, loading,
          name, paternal_surname, maternal_surname, number_phone, email, handleInputChange,
          saveCreate, saveUpdate, saveDelete, validaciones, closeModalSeller
        }
        }

      />

      <DialogTransfer
      {
        ...{
          modalTransfer, closeTransfer,
          listSellers,
          handleInputChange,
          id_seller,id_seller_origin, id_seller_destiny, handleTransfer,
          showConfirm, setShowConfirm, getDoctorsCount, doctorCount,
          errorTransfer, setErrorTransfer, handleShowConfirm,listSellerAll

        }
      }
      
      />

    </Fragment>
  )
}
